import { Fork, Invoke } from '@swf/components/StarsWizard/Flow';
import { Action, type FlowConfig } from '@swf/core/types/Wizard';

import PaymentVerificationMenu from '../components/PaymentVerificationMenu/PaymentVerificationMenu';
import PaymentVerificationPage from '../components/PaymentVerificationPage/PaymentVerificationPage';
import PaymentVerificationSummary from '../components/PaymentVerificationSummary/PaymentVerificationSummary';

const usePaymentVerificationDepositFlow = (): FlowConfig => {
  const jumpToFeatureStep = {
    name: 'jumpToFeatureStep',
    entry: Action.GoJump
  };

  const backToDeposit = new Invoke('jumpBackToDeposit', jumpToFeatureStep);

  const paymentVerificationState = new Invoke(
    'paymentVerificationSave',
    PaymentVerificationSummary,
    PaymentVerificationPage
  );

  const verificationMenuSelectState = new Fork(
    'paymentVerificationMenuSelect',
    [PaymentVerificationPage],
    [backToDeposit]
  );
  return [
    PaymentVerificationMenu,
    verificationMenuSelectState,
    PaymentVerificationPage,
    paymentVerificationState,
    PaymentVerificationSummary,
    backToDeposit,
    jumpToFeatureStep
  ];
};
export default usePaymentVerificationDepositFlow;
